import { render, staticRenderFns } from "./ProjectDetailsNotes.vue?vue&type=template&id=5c8a054c&scoped=true&"
import script from "./ProjectDetailsNotes.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsNotes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsNotes.vue?vue&type=style&index=0&id=5c8a054c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a054c",
  null
  
)

export default component.exports